import { Component } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'
import Tappable from 'react-tappable/lib/Tappable'

import Image from 'components/image'
import Link from 'components/link'
import { isTouchDevice } from 'lib/touch'
import * as blUrls from 'lib/urls'
import Card from 'components/card'
import FaIcon from 'components/fa-icon'
import css from './category-grid.scss'

const CategoryGrid = ({
  callout,
  categories,
  parentSlugSet,
  useRouter,
  smallGutter,
}) => {
  const className = classNames({ phm: smallGutter })
  return (
    <Row>
      {categories.map((cat) => {
        if (cat.hidden) return null
        return (
          <Col
            className={className}
            key={cat.urlSlug}
            md={4}
            style={{ padding: '2%' }}
            xs={6}
          >
            <Category
              {...cat}
              slugSet={[...parentSlugSet, cat.urlSlug]}
              useRouter={useRouter}
            />
          </Col>
        )
      })}
      {callout && (
        <Col className={className} key="callout" md={4} xs={6}>
          <CategoryCallout {...callout} />
        </Col>
      )}
    </Row>
  )
}

CategoryGrid.defaultProps = {
  parentSlugSet: [],
  smallGutter: false,
  useRouter: true,
}

class Category extends Component {
  static propTypes = {
    fullBleedImage: PropTypes.bool,
    imageUrl: PropTypes.string.isRequired,
    slugSet: PropTypes.array.isRequired,
    smallGutter: PropTypes.bool,
    title: PropTypes.string.isRequired,
    urlSlug: PropTypes.string.isRequired,
    useRouter: PropTypes.bool.isRequired,
  }

  state = {}

  componentDidMount() {
    this.setState({
      isTouchDevice: isTouchDevice(),
    })
  }

  render() {
    const { fullBleedImage, imageUrl, title, urlSlug, slugSet, useRouter } =
      this.props

    const path = blUrls.storeCategoryPath(urlSlug)
    const tappableProps = useRouter
      ? { to: { pathname: path, state: { slugSet } } }
      : { url: path }

    return (
      <Card>
        <Tappable component={Link} {...tappableProps}>
          <div
            className={classNames(css.wrapper, {
              [css.hoverEnabled]: !this.state.isTouchDevice,
            })}
          >
            <div
              className={classNames(
                'hover-overlay hover-darken',
                css.fullHeightPlaceholder
              )}
            >
              <div
                className={classNames({
                  [css.categoryImageWrapper]: !fullBleedImage,
                })}
              >
                <Image
                  alt={title}
                  className="img-responsive center-block"
                  lazyLoad={false}
                  src={imageUrl}
                />
              </div>
            </div>
            <div className={css.titleWrapper}>
              <div className={css.title}>{title}</div>
              <FaIcon className={css.chevron} icon="chevron-right" />
            </div>
          </div>
        </Tappable>
      </Card>
    )
  }
}

const CategoryCallout = ({ message, title, small }) => (
  <div className={css.wrapper}>
    <div className={classNames(css.categoryCallout, { [css.small]: small })}>
      <div className="center-y full-width text-center">
        <div className={classNames(css.heartIcon, 'mtn')}>
          <i className="fa fa-heart icon-filled-primary" />
        </div>
        <div
          className={classNames(css.heading, 'mas', { 'hidden-xs': !small })}
        >
          {title}
        </div>
        <div className={classNames(css.message, 'mas mbm')}>{message}</div>
      </div>
    </div>
  </div>
)

CategoryCallout.defaultProps = {
  small: false,
}

CategoryGrid.propTypes = {
  callout: PropTypes.shape({
    message: PropTypes.string,
    title: PropTypes.string,
  }),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      urlSlug: PropTypes.string.isRequired,
    })
  ).isRequired,
  parentSlugSet: PropTypes.array,
}

export default CategoryGrid
export { Category, CategoryCallout }
